import { Howl} from 'howler'

let audioRecording = null
let currentRecording = ''
let isPaused = false

function playAudio(recording, button)
{
  if(audioRecording && currentRecording === recording && !isPaused) {
    pauseAudio()
    isPaused = true
    return false
  }

  if(audioRecording && currentRecording === recording && isPaused) {
    audioRecording.play()
    isPaused = false
    button.addClass('playing')
    return false
  }

  if(audioRecording ) {
    stopAudio()
  }

  currentRecording = recording

  //audioRecording = new Audio(recording)
  audioRecording = new Howl({
    src: [recording]
  })

  audioRecording.play()

  button.addClass('playing')

  audioRecording.on('end', function(){
    audioRecording = null
    button.removeClass('playing')
    currentRecording = ''
    $('body').find('.playing').removeClass('playing')
  });

}

function pauseAudio()
{
  if(audioRecording) {
    audioRecording.pause()
    $('body').find('.playing').removeClass('playing')
  }
}

function stopAudio()
{
  if(audioRecording) {
    audioRecording.pause()
    audioRecording = null
    $('body').find('.playing').removeClass('playing')
  }
}

export { playAudio, stopAudio, pauseAudio }